import { IApp } from "@/types";
import { getPastNMonths } from "@/utils";
import _ from "lodash";

abstract class AbstractSource {
  syncs: IApp.Sync[] = [];
  isSynced(dataTypes: IApp.DataType[] = this.getDataTypes()): boolean {
    const months = getPastNMonths(16, new Date());
    return _.every(dataTypes, (dataType) => {
      const syncs = _.filter(this.syncs, {
        dataType,
        status: IApp.SyncStatus.Completed
      });
      return _.every(months, (month) => _.some(syncs, { month }));
    });
  }
  getDataTypeSyncs(dataType: IApp.DataType): IApp.Sync[] {
    const months = getPastNMonths(16, new Date());
    const filtered = _.filter(this.syncs, { dataType });
    for (const month of months) {
      if (!_.some(filtered, { month })) {
        filtered.push({
          dataType,
          month,
          status: IApp.SyncStatus.NotStarted
        });
      }
    }
    return _.sortBy(filtered, "month");
  }
  abstract getDataTypes(): IApp.DataType[];
}

export default AbstractSource;
